export function shouldRefetchData(timeStamp){
  let currentTime = new Date().valueOf();
  if( !timeStamp || currentTime > parseInt(timeStamp, 10)){
    return true
  }
  return false
}



// WEBPACK FOOTER //
// ./src/app/actions/refetchData.js